<template>
  <DialogBase
    :visible.sync="visible"
    :title="dialogTitle"
    size="md"
    :confirm-loading="exporting"
    confirm-text="Xuất file Excel"
    cancel-text="Đóng"
    :use-panel="true"
    :panel-title="dialogTitle"
    :panel-subtitle="dialogSubtitle"
    panel-icon="el-icon-download"
    @confirm="handleExport"
    @cancel="handleClose"
  >
    <el-form
      ref="exportForm"
      :model="form"
      :rules="formRules"
      label-position="top"
      class="evl-export-form"
    >
      <!-- 1. CHỌN HÌNH THỨC NHẬN XÉT -->
      <div class="evl-export-card">
        <label class="evl-export-card__label">
          <i class="el-icon-collection-tag" /> 1. Chọn loại nhận xét
        </label>
        <div class="evl-type-radio-group">
          <el-radio-group v-model="form.type" size="medium" @change="handleTypeChange">
            <el-radio-button label="DAILY">
              <i class="el-icon-date" /> Ngày
            </el-radio-button>
            <el-radio-button label="WEEKLY">
              <i class="el-icon-document" /> Tuần
            </el-radio-button>
            <el-radio-button label="MONTHLY">
              <i class="el-icon-notebook-2" /> Tháng
            </el-radio-button>
            <el-radio-button label="PERIODIC">
              <i class="el-icon-s-claim" /> Định kỳ
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <!-- 2. CHỌN CHẾ ĐỘ XUẤT SHEET -->
      <div class="evl-export-card">
        <label class="evl-export-card__label">
          <i class="el-icon-files" /> 2. Quy cách tạo Sheet
        </label>
        <div class="evl-mode-radios">
          <el-radio v-model="form.mode" label="STUDENT_SHEETS" border size="medium">
            <div class="evl-mode-content">
              <strong>Mỗi học sinh 1 Sheet riêng</strong>
              <span>Sổ nhật ký theo dõi chi tiết từng học sinh qua nhiều mốc thời gian</span>
            </div>
          </el-radio>
          <el-radio v-model="form.mode" label="CLASS_SHEET" border size="medium">
            <div class="evl-mode-content">
              <strong>Bảng tổng hợp cả lớp (1 Sheet)</strong>
              <span>Một trang tổng quan toàn bộ học sinh tại mốc thời gian được chọn</span>
            </div>
          </el-radio>
        </div>
      </div>

      <!-- 3. CHỌN KHOẢNG THỜI GIAN -->
      <div class="evl-export-card">
        <label class="evl-export-card__label">
          <i class="el-icon-time" /> 3. Thời gian xuất
        </label>

        <!-- Nếu chọn DAILY -->
        <div v-if="form.type === 'DAILY'">
          <div v-if="form.mode === 'STUDENT_SHEETS'" class="evl-time-picker-row">
            <el-date-picker
              v-model="form.dailyRange"
              type="daterange"
              range-separator="đến"
              start-placeholder="Từ ngày"
              end-placeholder="Đến ngày"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              :clearable="false"
              style="width: 100%"
            />
            <p class="evl-time-hint">Hệ thống sẽ tạo sheet cho từng học sinh và thống kê nhật ký qua từng ngày trong khoảng thời gian này.</p>
          </div>
          <div v-else class="evl-time-picker-row">
            <el-date-picker
              v-model="form.singleDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              placeholder="Chọn ngày xuất"
              :clearable="false"
              style="width: 100%"
            />
          </div>
        </div>

        <!-- Nếu chọn WEEKLY -->
        <div v-else-if="form.type === 'WEEKLY'">
          <div v-if="form.mode === 'STUDENT_SHEETS'" class="evl-time-picker-row">
            <el-date-picker
              v-model="form.weeklyRange"
              type="daterange"
              range-separator="đến"
              start-placeholder="Tuần bắt đầu"
              end-placeholder="Tuần kết thúc"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              :clearable="false"
              style="width: 100%"
            />
            <p class="evl-time-hint">Hệ thống sẽ xuất các tuần nhận xét trong khoảng thời gian được chọn vào sheet riêng của từng học sinh.</p>
          </div>
          <div v-else class="evl-time-picker-row">
            <el-date-picker
              v-model="form.singleWeek"
              type="week"
              value-format="yyyy-MM-dd"
              format="Tuần WW (từ dd/MM/yyyy)"
              placeholder="Chọn tuần xuất"
              :clearable="false"
              style="width: 100%"
            />
          </div>
        </div>

        <!-- Nếu chọn MONTHLY -->
        <div v-else-if="form.type === 'MONTHLY'">
          <div v-if="form.mode === 'STUDENT_SHEETS'" class="evl-month-range-grid">
            <div class="evl-month-col">
              <span class="evl-sub-label">Từ tháng:</span>
              <el-date-picker
                v-model="form.fromMonth"
                type="month"
                value-format="yyyy-MM"
                format="MM/yyyy"
                placeholder="Chọn từ tháng"
                :clearable="false"
                style="width: 100%"
              />
            </div>
            <div class="evl-month-col">
              <span class="evl-sub-label">Đến tháng:</span>
              <el-date-picker
                v-model="form.toMonth"
                type="month"
                value-format="yyyy-MM"
                format="MM/yyyy"
                placeholder="Chọn đến tháng"
                :clearable="false"
                style="width: 100%"
              />
            </div>
          </div>
          <div v-else class="evl-time-picker-row">
            <el-date-picker
              v-model="form.singleMonth"
              type="month"
              value-format="yyyy-MM"
              format="MM/yyyy"
              placeholder="Chọn tháng xuất"
              :clearable="false"
              style="width: 100%"
            />
          </div>
        </div>

        <!-- Nếu chọn PERIODIC -->
        <div v-else-if="form.type === 'PERIODIC'" class="evl-time-picker-row">
          <el-date-picker
            v-model="form.periodicYear"
            type="year"
            value-format="yyyy"
            format="yyyy"
            placeholder="Chọn năm học"
            :clearable="false"
            style="width: 100%"
          />
        </div>
      </div>

      <!-- 4. CHỌN HỌC SINH -->
      <div class="evl-export-card">
        <div class="evl-students-header">
          <label class="evl-export-card__label" style="margin-bottom: 0;">
            <i class="el-icon-user" /> 4. Chọn học sinh
            <el-tag size="mini" type="primary" class="ml-2">
              Đã chọn: {{ selectedStudentIds.length }} / {{ allStudents.length }} học sinh
            </el-tag>
          </label>
          <div class="evl-students-actions">
            <el-button size="mini" type="text" icon="el-icon-check" @click="selectAllStudents">
              Chọn tất cả
            </el-button>
            <el-button size="mini" type="text" icon="el-icon-close" class="text-danger" @click="deselectAllStudents">
              Bỏ chọn
            </el-button>
          </div>
        </div>

        <div class="evl-students-picker">
          <el-select
            v-model="selectedStudentIds"
            multiple
            filterable
            collapse-tags
            placeholder="Tìm kiếm và chọn học sinh..."
            style="width: 100%"
          >
            <el-option
              v-for="student in allStudents"
              :key="student.studentId"
              :label="student.studentName"
              :value="student.studentId"
            />
          </el-select>
        </div>

        <div v-if="selectedStudentIds.length > 0" class="evl-students-tags">
          <el-tag
            v-for="id in selectedStudentIds"
            :key="id"
            closable
            size="small"
            class="evl-student-tag"
            @close="removeStudent(id)"
          >
            {{ getStudentName(id) }}
          </el-tag>
        </div>
        <div v-else class="evl-students-empty">
          <i class="el-icon-warning-outline" /> Vui lòng chọn ít nhất 1 học sinh để xuất file!
        </div>
      </div>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ExportEvaluationExcel, { generateMockStudentRangeData } from "@/modules/evaluation/utils/ExportEvaluationExcel";
import EvaluationService from "@/modules/evaluation/services/EvaluationService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import moment from "moment";

export default {
  name: "EvaluationExportDialog",
  components: { DialogBase },
  props: {
    classId: {
      type: [Number, String],
      default: "",
    },
    classInfo: {
      type: Object,
      default: () => ({
        className: "",
        schoolName: "",
        teacherName: "",
      }),
    },
  },
  data() {
    return {
      visible: false,
      exporting: false,
      allStudents: [],
      selectedStudentIds: [],
      currentTableData: [],
      currentPeriodicData: [],
      form: {
        type: "DAILY",
        mode: "STUDENT_SHEETS", // "STUDENT_SHEETS" | "CLASS_SHEET"
        dailyRange: [moment().startOf("month").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        singleDate: moment().format("YYYY-MM-DD"),
        weeklyRange: [moment().startOf("month").startOf("isoWeek").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        singleWeek: moment().startOf("isoWeek").format("YYYY-MM-DD"),
        fromMonth: moment().startOf("year").format("YYYY-MM"),
        toMonth: moment().format("YYYY-MM"),
        singleMonth: moment().format("YYYY-MM"),
        periodicYear: String(moment().year()),
      },
    };
  },
  computed: {
    dialogTitle() {
      if (this.form.mode === "STUDENT_SHEETS") {
        return "Xuất Excel nâng cao (Mỗi học sinh 1 Sheet)";
      }
      const titleMap = {
        DAILY: "Xuất Excel nhận xét ngày",
        WEEKLY: "Xuất Excel nhận xét tuần",
        MONTHLY: "Xuất Excel nhận xét tháng",
        PERIODIC: "Xuất Excel nhận xét định kỳ",
      };
      return titleMap[this.form.type] || "Xuất file Excel nhận xét";
    },
    dialogSubtitle() {
      if (this.form.mode === "STUDENT_SHEETS") {
        return "Xuất sổ nhật ký theo dõi chi tiết từng học sinh qua nhiều mốc thời gian (mỗi học sinh 1 Sheet riêng)";
      }
      const typeLabelMap = {
        DAILY: "ngày",
        WEEKLY: "tuần",
        MONTHLY: "tháng",
        PERIODIC: "định kỳ",
      };
      return `Bảng tổng hợp nhận xét của lớp theo ${typeLabelMap[this.form.type] || "thời gian"} (1 Sheet)`;
    },
  },
  methods: {
    open({
      type = "DAILY",
      mode = "CLASS_SHEET",
      currentDate = moment().format("YYYY-MM-DD"),
      allStudents = [],
      preSelectedIds = [],
      tableData = [],
      periodicData = [],
    }) {
      this.form.type = type;
      this.form.mode = mode;
      this.allStudents = allStudents || [];
      this.currentTableData = tableData || [];
      this.currentPeriodicData = periodicData || [];

      // Mặc định chọn các học sinh được tick chọn hoặc tất cả
      if (preSelectedIds && preSelectedIds.length > 0) {
        this.selectedStudentIds = [...preSelectedIds];
      } else {
        this.selectedStudentIds = this.allStudents.map((s) => s.studentId);
      }

      // Khởi tạo các mốc thời gian
      if (type === "DAILY") {
        this.form.singleDate = currentDate;
        this.form.dailyRange = [
          moment(currentDate).startOf("month").format("YYYY-MM-DD"),
          currentDate,
        ];
      } else if (type === "WEEKLY") {
        this.form.singleWeek = currentDate;
        this.form.weeklyRange = [
          moment(currentDate).startOf("month").startOf("isoWeek").format("YYYY-MM-DD"),
          currentDate,
        ];
      } else if (type === "MONTHLY") {
        this.form.singleMonth = moment(currentDate, ["YYYY-MM", "YYYY-MM-DD"]).format("YYYY-MM");
        this.form.toMonth = this.form.singleMonth;
        this.form.fromMonth = moment(currentDate).startOf("year").format("YYYY-MM");
      } else if (type === "PERIODIC") {
        this.form.periodicYear = String(moment(currentDate).year() || moment().year());
      }

      this.visible = true;
    },

    handleTypeChange(type) {
      if (type === "MONTHLY" && !this.form.fromMonth) {
        this.form.fromMonth = moment().startOf("year").format("YYYY-MM");
        this.form.toMonth = moment().format("YYYY-MM");
      }
    },

    selectAllStudents() {
      this.selectedStudentIds = this.allStudents.map((s) => s.studentId);
    },

    deselectAllStudents() {
      this.selectedStudentIds = [];
    },

    removeStudent(studentId) {
      this.selectedStudentIds = this.selectedStudentIds.filter((id) => id !== studentId);
    },

    getStudentName(studentId) {
      const found = this.allStudents.find((s) => s.studentId === studentId);
      return found ? found.studentName : `Học sinh ${studentId}`;
    },

    async handleExport() {
      if (this.selectedStudentIds.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn ít nhất 1 học sinh để xuất file!");
        return;
      }

      this.exporting = true;
      try {
        const filteredStudents = this.allStudents.filter((s) =>
          this.selectedStudentIds.includes(s.studentId)
        );

        if (this.form.mode === "CLASS_SHEET") {
          // ─── DẠNG 1: XUẤT TỔNG HỢP CẢ LỚP (1 SHEET) ───────────────
          const exportPayload = {
            classId: this.classId,
            type: this.form.type,
            studentIds: this.selectedStudentIds,
          };
          if (this.form.type === "DAILY") exportPayload.date = this.form.singleDate;
          else if (this.form.type === "WEEKLY") exportPayload.date = this.form.singleWeek;
          else if (this.form.type === "MONTHLY") exportPayload.date = this.form.singleMonth;
          else if (this.form.type === "PERIODIC") exportPayload.date = this.form.periodicYear;

          let beData = null;
          try {
            const res = await EvaluationService.getExportClassSheetData(exportPayload);
            if (res && res.data && res.data.data) {
              beData = res.data.data;
            }
          } catch (apiErr) {
            console.warn("API /web/evaluation/export/class-sheet chưa sẵn sàng từ BE, sử dụng fallback:", apiErr);
          }

          if (this.form.type === "DAILY") {
            const dataToExport = beData?.students || this.currentTableData.filter((s) =>
              this.selectedStudentIds.includes(s.studentId)
            );
            await ExportEvaluationExcel.exportDailyClassExcel({
              classInfo: this.classInfo,
              date: this.form.singleDate,
              dataList: dataToExport.length > 0 ? dataToExport : this.currentTableData,
            });
          } else if (this.form.type === "WEEKLY") {
            const dataToExport = beData?.students || this.currentTableData.filter((s) =>
              this.selectedStudentIds.includes(s.studentId)
            );
            await ExportEvaluationExcel.exportWeeklyClassExcel({
              classInfo: this.classInfo,
              date: this.form.singleWeek,
              dataList: dataToExport.length > 0 ? dataToExport : this.currentTableData,
            });
          } else if (this.form.type === "MONTHLY") {
            const dataToExport = beData?.students || this.currentTableData.filter((s) =>
              this.selectedStudentIds.includes(s.studentId)
            );
            await ExportEvaluationExcel.exportMonthlyClassExcel({
              classInfo: this.classInfo,
              date: this.form.singleMonth,
              dataList: dataToExport.length > 0 ? dataToExport : this.currentTableData,
            });
          } else if (this.form.type === "PERIODIC") {
            const dataToExport = beData?.students || this.currentPeriodicData.filter((s) =>
              this.selectedStudentIds.includes(s.studentId)
            );
            await ExportEvaluationExcel.exportPeriodicClassExcel({
              classInfo: this.classInfo,
              year: this.form.periodicYear,
              dataList: dataToExport.length > 0 ? dataToExport : this.currentPeriodicData,
            });
          }
        } else {
          // ─── DẠNG 2: XUẤT CHI TIẾT TỪNG HỌC SINH (MỖI HS 1 SHEET) ──
          const exportPayload = {
            classId: this.classId,
            type: this.form.type,
            studentIds: this.selectedStudentIds,
          };
          if (this.form.type === "DAILY") {
            exportPayload.fromDate = this.form.dailyRange[0];
            exportPayload.toDate = this.form.dailyRange[1];
          } else if (this.form.type === "WEEKLY") {
            exportPayload.fromDate = this.form.weeklyRange[0];
            exportPayload.toDate = this.form.weeklyRange[1];
          } else if (this.form.type === "MONTHLY") {
            exportPayload.fromMonth = this.form.fromMonth;
            exportPayload.toMonth = this.form.toMonth;
          } else if (this.form.type === "PERIODIC") {
            exportPayload.year = this.form.periodicYear;
          }

          let beData = null;
          try {
            const res = await EvaluationService.getExportStudentSheetsData(exportPayload);
            if (res && res.data && res.data.data) {
              beData = res.data.data;
            }
          } catch (apiErr) {
            console.warn("API /web/evaluation/export/student-sheets chưa sẵn sàng từ BE, sử dụng mock fallback:", apiErr);
          }

          if (this.form.type === "DAILY") {
            const studentsData = beData?.students || generateMockStudentRangeData({
              studentList: filteredStudents,
              type: "DAILY",
              dateRange: this.form.dailyRange,
            });
            await ExportEvaluationExcel.exportDailyStudentSheetsExcel({
              classInfo: this.classInfo,
              dateRange: this.form.dailyRange,
              studentsData,
            });
          } else if (this.form.type === "WEEKLY") {
            const studentsData = beData?.students || generateMockStudentRangeData({
              studentList: filteredStudents,
              type: "WEEKLY",
              dateRange: this.form.weeklyRange,
            });
            await ExportEvaluationExcel.exportWeeklyStudentSheetsExcel({
              classInfo: this.classInfo,
              dateRange: this.form.weeklyRange,
              studentsData,
            });
          } else if (this.form.type === "MONTHLY") {
            const studentsData = beData?.students || generateMockStudentRangeData({
              studentList: filteredStudents,
              type: "MONTHLY",
              dateRange: [this.form.fromMonth, this.form.toMonth],
            });
            await ExportEvaluationExcel.exportMonthlyStudentSheetsExcel({
              classInfo: this.classInfo,
              monthRange: [this.form.fromMonth, this.form.toMonth],
              studentsData,
            });
          } else if (this.form.type === "PERIODIC") {
            const studentsData = beData?.students || generateMockStudentRangeData({
              studentList: filteredStudents,
              type: "PERIODIC",
              year: this.form.periodicYear,
            });
            await ExportEvaluationExcel.exportPeriodicStudentSheetsExcel({
              classInfo: this.classInfo,
              year: this.form.periodicYear,
              studentsData,
            });
          }
        }

        NotifyMessage.leftCornerNotificationSuccess("Xuất file Excel thành công!");
        this.visible = false;
      } catch (err) {
        console.error("Export Excel error:", err);
        NotifyMessage.leftCornerNotificationError("Có lỗi xảy ra trong quá trình tạo file Excel!");
      } finally {
        this.exporting = false;
      }
    },

    handleClose() {
      this.visible = false;
      this.exporting = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";

.evl-export-form {
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.evl-export-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;

  &__label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13.5px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 10px;

    i {
      color: #2563eb;
      font-size: 15px;
    }
  }
}

.evl-type-radio-group {
  display: flex;
  /deep/ .el-radio-group {
    display: flex;
    width: 100%;
  }
  /deep/ .el-radio-button {
    flex: 1;
    text-align: center;
    .el-radio-button__inner {
      width: 100%;
      border-radius: 8px;
      font-weight: 600;
    }
  }
}

.evl-mode-radios {
  display: flex;
  flex-direction: column;
  gap: 8px;

  /deep/ .el-radio {
    margin-right: 0 !important;
    height: auto !important;
    padding: 10px 14px !important;
    border-radius: 10px !important;
    display: flex;
    align-items: flex-start;
    border-color: #e2e8f0;
    transition: all 0.2s;

    &.is-checked {
      background: #eff6ff;
      border-color: #93c5fd;
    }

    .el-radio__input {
      margin-top: 2px;
    }
  }
}

.evl-mode-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 4px;

  strong {
    font-size: 13.5px;
    color: #1e293b;
  }
  span {
    font-size: 12px;
    color: #64748b;
  }
}

.evl-time-picker-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.evl-time-hint {
  margin: 0;
  font-size: 12px;
  color: #64748b;
  font-style: italic;
}

.evl-month-range-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.evl-month-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.evl-sub-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.evl-students-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.evl-students-actions {
  display: flex;
  align-items: center;
  gap: 8px;

  /deep/ .el-button {
    padding: 0;
    font-weight: 600;
  }
  .text-danger {
    color: #ef4444;
  }
}

.evl-students-picker {
  margin-bottom: 8px;
}

.evl-students-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 110px;
  overflow-y: auto;
  padding: 4px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.evl-student-tag {
  border-radius: 6px;
}

.evl-students-empty {
  font-size: 12.5px;
  color: #f59e0b;
  padding: 8px;
  background: #fffbeb;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
